import React, {useEffect, useState} from "react";
import {Grid, Mui, AlertTypes, MainLoader} from "@leap4/frontend";
import {setAlert} from "../../../actions/alert";
import {getAllOrganizations} from "../../../actions/users";
import {useDispatch} from "react-redux";
import {IOrganization} from "../../organizations/interfaces/IOrganization";
import {OwnershipDashboard} from "../../organizations/Organization/ownerships/OwnershipDashbord";

const {MenuItem, Select, Typography} = Mui;



const DetailsForm = () => {
    const dispatch = useDispatch();
    const [currentOrganization, setCurrentOrganization] = useState<IOrganization>({
        _id: '', name: '', publisherLogin:{}, foreingAccess: {}
    })
    const [allOrganizations, setAllOrganizations] = useState<IOrganization[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const handleFormChange = (e: any) => {
        const org = allOrganizations.find(o => e.target.value === o._id)
        setCurrentOrganization({
            _id: org._id,
            name: org.name,
            publisherLogin:{},
            foreingAccess: {}
        })
    }

    useEffect(() => {
        let loadedOrganizations;
        (async () => {
            try {
                setIsLoading(true);
                loadedOrganizations = await getAllOrganizations(dispatch) as IOrganization[]
                setAllOrganizations(loadedOrganizations)
            } catch (err) {
                setAlert("Couldn't load organizations", AlertTypes.FAILURE)
            } finally {
                setIsLoading(false);
            }
        })()
    }, []);

    if (isLoading) {
        return <Grid item padding={0}>
            <MainLoader/>
        </Grid>
    }
    return (
        <>
            <Typography fontFamily={"Quicksand"} fontWeight={600} variant="h5">
                ADD OWNERSHIPS
            </Typography>
                <Grid container margin={"30px"} width='90%'>

                    <Select
                            disabled={isLoading}
                            onChange={handleFormChange}
                            value={currentOrganization?._id || 'NULL'}
                            name={currentOrganization.name}
                            fullWidth
                    >
                        <MenuItem disabled value={'NULL'}>
                            <em>Select Organization</em>
                        </MenuItem>


                    {allOrganizations.map(o => {
                        return <MenuItem key={o.name} divider value={o?._id }>{o?.name}</MenuItem>
                    })}
                    </Select>
                </Grid>
                {!currentOrganization._id ? ( <></>
            ) : (
                <Grid container gap={"10px"}>
                    <OwnershipDashboard
                        organization={currentOrganization}
                    />
                </Grid>
            )}

        </>
    )
}

export {DetailsForm}


